<template>
    <div class="edit">
        <merchant-status-bar
            v-if="!isNaN(formData.merchant_base_audit)"
            :status="formData.merchant_base_audit"
            :reason="formData.merchant_base_reasonNotPass"
        >
            <el-button class="status-btn" type="primary" @click="submit"
                >重新提交审核</el-button
            >
        </merchant-status-bar>
        <div v-for="template in montageTemplateList" :key="template._id">
            <retail-title :main-title="template.templateName"></retail-title>
            <div class="form-wrapper">
                <render-container
                    :schema="schemaObject[template._id]"
                    :formData="formData"
                    :formRulesProps="formRules"
                    :ref="`template_${template._id}`"
                ></render-container>
            </div>
        </div>
    </div>
</template>

<script>
import { v1 as uuid } from 'uuid'
import { parseJSONString } from './../../common/utils'
import editMixins from './../../common/mixins/editMixins'
import getMixins from './../../common/mixins/getMixins'
import { Cascader } from 'element-ui'
import { findDescendantByName } from './../../common/utils'
import MerchantStatusBar from './../../common/merchantStatusBar'
import transformTitle from './../../common/transform/transformTitle'

export default {
    name: 'edit',
    data() {
        return {
            businessParams: null,
            elCascaderRef: null
        }
    },
    mounted() {
        // generate uuid
        this.uuid = uuid()
        // get params from query
        const {
            channelNo,
            departId,
            departName,
            projectName,
            merchantType
        } = this.$route.query
        // save variables
        this.channelNo = channelNo
        this.departId = departId
        this.merchantType = merchantType
        this.departName = departName
        this.projectName = projectName
        this.businessParams = { channelNo, departId, merchantType }
        // get montage model object
        this.$apiServe.computerSettleIn
            .getMerchantEditDetail({
                channelNo,
                merchantType,
                departId,
                uuid: this.uuid
            })
            .then(res => {
                // --------添加字段联动属性-------
                // 给关联根字段添加 rule 联动属性
                let relationData = this.addRelation(res, businessParams)
                res.marketTemplateConfigInfo.templateDetailList =
                    relationData.templateDetailList
                // ---------------
                res.marketTemplateConfigInfo.templateDetailList = transformTitle(
                    res
                )
                const businessParams = { departId, merchantType }
                // 获取排序的模版
                this.montageTemplateList = this.getMontageTemplateList(res)
                // 如果有保存的数据，数据需回填
                this.formData = this.getFormData(this.montageTemplateList, res)
                // 生成每个模版的schema
                this.schemaObject = this.getSchemaObject(
                    this.montageTemplateList,
                    this.formData,
                    businessParams
                )
                this.formRules = this.getFormRules(
                    this.montageTemplateList,
                    businessParams
                )
                this.$nextTick(() => {
                    // 处理多选地址回显
                    this.elCascaderRef = findDescendantByName(
                        this,
                        Cascader.name
                    )
                    if (this.elCascaderRef) {
                        this.$nextTick(() => {
                            this.elCascaderRef.presentTags =
                                this.formData
                                    .merchant_ext_mutiBusinessZoneNameList || []
                        })
                    }
                })
            })
    },
    methods: {
        submit() {
            // 前端校验
            // 获取容器中的elForm getFormInstace
            const formInstanceList = this.montageTemplateList.map(({ _id }) =>
                this.getFormInstace(this.$refs[`template_${_id}`][0])
            )
            Promise.all(
                formInstanceList.map(
                    (formInstance, index) =>
                        new Promise((resolve, reject) => {
                            // 当前表单信息
                            const currentFormFieldList = this.montageTemplateList[
                                index
                            ].templateFieldParamList.map(field => ({
                                ...field,
                                configSetting: parseJSONString(
                                    field.configSetting,
                                    {}
                                )
                            }))
                            // 联动表单校验 formcreat 组件的校验结果
                            let FCValid = this.FormCreatValidate(
                                this.formData,
                                currentFormFieldList
                            )
                            formInstance.validate(valid => {
                                FCValid && valid
                                    ? resolve(currentFormFieldList)
                                    : reject(valid)
                            })
                        })
                )
            )
                .then(currentFormFieldList => {
                    const currentFormData = this.addRelationFieldValue(
                        this.formData,
                        currentFormFieldList.flat()
                    )
                    // 特殊校验 蓝鲸校验
                    // 营业执照与公司名称校验
                    const { merchant_base_companyName } = currentFormData
                    const merchant_spec_bizLicense_ImgText =
                        currentFormData['merchant_spec_bizLicense-ImgText'] ||
                        []
                    const merchant_base_businessRegisNumber_find =
                        merchant_spec_bizLicense_ImgText &&
                        merchant_spec_bizLicense_ImgText.find(
                            item =>
                                item.key === 'merchant_base_businessRegisNumber'
                        )
                    if (merchant_base_businessRegisNumber_find) {
                        const merchant_base_businessRegisNumber =
                            merchant_base_businessRegisNumber_find.value
                        this.$apiServe.computerSettleIn
                            .checkMerchantCompanyBlueWhale({
                                merchant_base_companyName,
                                merchant_base_businessRegisNumber
                            })
                            .then(() => {
                                // 校验通过，继续提交
                                this.saveForm(currentFormData)
                            })
                            .catch(err => {
                                console.log(err)
                                this.$confirm(err.msg, '提示', {
                                    confirmButtonText: '继续提交',
                                    cancelButtonText: '取消',
                                    type: 'warning'
                                })
                                    .then(() => {
                                        // 继续提交
                                        this.saveForm(currentFormData)
                                    })
                                    .catch(() => {
                                        // 返回继续修改
                                        return
                                    })
                            })
                    } else {
                        this.saveForm(currentFormData)
                    }
                })
                // false
                .catch(err => {
                    console.log(err)
                })
        },
        saveForm(currentFormData) {
            let params = {
                data: currentFormData,
                channelNo: this.channelNo,
                finished: true,
                uuid: this.uuid,
                departId: this.departId,
                // 当前页面表单 字段
                fieldList: Object.keys(currentFormData),
                merchantType: this.merchantType
            }
            // 非堵塞特殊处理
            // TODO 发送多选地址的name，多级地址，只能有一个
            // ---------------------------------------
            this.elCascaderRef = findDescendantByName(this, Cascader.name)
            if (this.elCascaderRef) {
                params.data.merchant_ext_mutiBusinessZoneNameList = this.elCascaderRef.presentTags.map(
                    ({ text }) => ({ text })
                )
                params.fieldList.push('merchant_ext_mutiBusinessZoneNameList')
            }
            // ---------------------------------------
            this.$apiServe.computerSettleIn
                .saveMerchantForm(params)
                .then(() => {
                    this.$router.push({
                        name: 'detailMerchantComputerSettleIn',
                        query: this.businessParams
                    })
                })
        }
    },
    mixins: [editMixins, getMixins],
    components: { MerchantStatusBar }
}
</script>

<style lang="scss" scoped>
.form-wrapper {
    width: 460px;
    margin: 0 auto;
}
</style>
